import { ToastOptions } from "./types";

type ToastFn = (msg: React.ReactNode, opts?: ToastOptions) => void;

type ToastApi = {
  success: ToastFn;
  info: ToastFn;
  warning: ToastFn;
  error: ToastFn;
};

let toastRef: ToastApi | null = null;

export const setToastRef = (ref: ToastApi) => {
  toastRef = ref;
};

export const toast: ToastApi = {
  success: (msg, opts) => toastRef?.success(msg, opts),
  info: (msg, opts) => toastRef?.info(msg, opts),
  warning: (msg, opts) => toastRef?.warning(msg, opts),
  error: (msg, opts) => toastRef?.error(msg, opts),
};
